export default __webpack_public_path__ + "static/media/hrp-small-use-logo-white.2ef91f1e.svg";